import { t } from 'i18next'

import { SpendBarChart } from '~/modules/retailMedia/components/BudgetConsumptionReport'
import useInView from '~/modules/retailMedia/hooks/useInView'
import {
  isNoSpendDataError,
  useHourlySpend
} from '~/modules/retailMedia/hooks/useSpendReports'

import * as S from '../../styles'
import ChartBox from '../ChartBox'
import DailyFilter from '../DailyFilter'

export interface HourlySpendSectionProps {
  campaignId: string
  selectedDay: string
  onDayChange: (day: string) => void
  dateRange: { start_date: string; end_date: string }
  overviewReady: boolean
  campaignStartAt?: string
}

const HourlySpendSection = ({
  campaignId,
  selectedDay,
  onDayChange,
  dateRange,
  overviewReady,
  campaignStartAt
}: HourlySpendSectionProps) => {
  const [ref, isInView] = useInView()
  const { data, isPending, isFetching, error, refetch } = useHourlySpend(
    campaignId,
    { date: selectedDay },
    isInView && overviewReady
  )

  return (
    <S.Section ref={ref}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '20px'
        }}
      >
        <S.SectionTitle style={{ marginBottom: 0 }}>
          {t('rm:spendReport.section.hourlySpend')}
        </S.SectionTitle>
        <DailyFilter
          loading={!overviewReady}
          selectedDay={selectedDay}
          onDayChange={onDayChange}
          dateRange={dateRange}
          campaignStartAt={campaignStartAt}
        />
      </div>
      <ChartBox
        loading={!isInView || (isPending && !data && !error)}
        refreshing={isInView && isFetching && (!!data || !!error)}
      >
        {(data || error) && (
          <SpendBarChart
            {...(data ?? {})}
            error={!!error}
            errorMessage={
              isNoSpendDataError(error)
                ? t('rm:spendReport.error.noSpendData')
                : undefined
            }
            onRetry={isNoSpendDataError(error) ? undefined : refetch}
          />
        )}
      </ChartBox>
    </S.Section>
  )
}

export default HourlySpendSection
